<button
  class="mobile-only"
  mat-icon-button
  [matMenuTriggerFor]="editorMenu"
  aria-label="{{ 'ORDERS.MOBILE_MENU_TRIGGER' | translate }}">
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu class="mobile-only" #editorMenu="matMenu" yPosition="below">
  <button mat-menu-item [disabled]="!canSave()" (click)="save.emit()">
    <mat-icon>save</mat-icon>
    <span>{{ 'DIALOGS.SAVE' | translate }}</span>
  </button>
  <span style="display: block" [matTooltip]="tooltipForFinalizeButton() ?? ''" [matTooltipDisabled]="canFinalize()">
    <button mat-menu-item [disabled]="!canFinalize()" (click)="finalize.emit()">
      <mat-icon>check_circle</mat-icon>
      <span>{{ 'ORDERS.FINISH' | translate }}</span>
    </button>
  </span>
  <lfw-menu-vertical-divider />
  <button mat-menu-item [disabled]="!canClose()" (click)="closeForm.emit()">
    <mat-icon>close</mat-icon>
    <span>{{ 'DIALOGS.CLOSE' | translate }}</span>
  </button>
</mat-menu>
